/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

// import getFilterWithCol from '../../../helpers/getFilterWithCol';
// import { sizeChoices } from '../helpers';

const isNotToggle = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'TOGGLE',
]);

const isNotPlacementModal = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'toggle_placement',
  '!==',
  'MODAL',
]);

export default [
  ...[
    ['FieldRadio', {
      name: 'toggle_placement',
      label: null,
      block: true,
      choices: [{
        label: 'Before',
        value: 'BEFORE',
      }, {
        label: 'After',
        value: 'AFTER',
      }, {
        label: 'Modal',
        value: 'MODAL',
      }],
      initialValue: 'MODAL',
    }],
    ['FieldRadio', {
      name: 'toggle_mode',
      label: null,
      block: true,
      choices: [{
        label: 'Trigger',
        value: 'TRIGGER',
      }, {
        label: 'Enter',
        value: 'ENTER',
      }, {
        label: 'Inactive',
        value: 'INACTIVE',
      }, {
        label: 'Leave',
        value: 'LEAVE',
      }],
      initialValue: 'TRIGGER',
      skip: [isNotPlacementModal],
    }],
    ['FieldText', {
      name: 'toggle_duration',
      label: null,
      prefix: 'Time before triggering:',
      addonAfter: 'sec',
      skip: [
        (props) => {
          const form = props?.form;
          const placement = form.getFieldValue('toggle_placement');
          if (placement !== 'MODAL') {
            return true;
          }
          const mode = form.getFieldValue('toggle_mode');
          if (!['ENTER', 'INACTIVE'].includes(mode)) {
            return true;
          }
          return false;
        },
      ],
      align: 'right',
      type: 'number',
      rules: [
        ['validation.isNumber'],
      ],
      col: { xs: 24, lg: 8 },
    }],
    ['FieldText', {
      name: 'toggle_period',
      label: null,
      prefix: 'Period:',
      addonAfter: 'day(s)',
      skip: [
        (props) => {
          const form = props?.form;
          const placement = form.getFieldValue('toggle_placement');
          if (placement !== 'MODAL') {
            return true;
          }
          const mode = form.getFieldValue('toggle_mode');
          if (!['ENTER', 'INACTIVE', 'LEAVE'].includes(mode)) {
            return true;
          }
          return false;
        },
      ],
      align: 'right',
      type: 'number',
      initialValue: 1,
      rules: [
        ['validation.isNumber'],
      ],
      col: { xs: 24, lg: 8 },
    }],
    ['FieldText', {
      name: 'toggle_repeatCount',
      label: null,
      prefix: 'Repeat:',
      addonAfter: 'times',
      initialValue: 0,
      skip: [
        (props) => {
          const form = props?.form;
          const placement = form.getFieldValue('toggle_placement');
          if (placement !== 'MODAL') {
            return true;
          }
          const mode = form.getFieldValue('toggle_mode');
          if (!['ENTER', 'INACTIVE', 'LEAVE'].includes(mode)) {
            return true;
          }
          return false;
        },
      ],
      align: 'right',
      type: 'number',
      rules: [
        ['validation.isNumber'],
      ],
      col: { xs: 24, lg: 8 },
    }],
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotToggle, ...(fieldConfig.preSkip || [])],
    },
  ])),
  ['FieldContentBuilderItems', {
    name: 'toggle_trigger',
    preSkip: [isNotToggle],
    skip: [[
      'condition.and',
      [
        [
          'condition.testFieldValue',
          'toggle_mode',
          '!==',
          'TRIGGER',
        ], [
          'condition.testFieldValue',
          'toggle_placement',
          '===',
          'MODAL',
        ],
      ],
    ]],
    maxCount: 1,
    placeholderContent: 'Add a trigger...',
  }],
  ['FieldContentBuilderItems', {
    name: 'toggle_items',
    preSkip: [isNotToggle],
    maxCount: 1,
    placeholderContent: 'Add content...',
  }],
];
